import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.production';

export interface BlogArticle {
  id: number;
  slug: string;
  title: string;
  summary: string;
  image: string;
  content: string;
  date: string;
  author: string;
  authorImage?: string;
  tags: string[];
}

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  private readonly articlesUrl = `/assets/blog-articles.json?v=${environment.VERSION}`;

  constructor(private http: HttpClient) { }

  getArticles(): Observable<BlogArticle[]> {
    console.log('BlogService - loading articles from:', this.articlesUrl);
    return this.http.get<BlogArticle[]>(this.articlesUrl);
  }

  getArticleById(id: number): Observable<BlogArticle | undefined> {
    return new Observable(observer => {
      this.getArticles().subscribe(articles => {
        const article = articles.find(a => a.id === id);
        observer.next(article);
        observer.complete();
      });
    });
  }

  getArticleBySlug(slug: string): Observable<BlogArticle | undefined> {
    return new Observable(observer => {
      this.getArticles().subscribe(articles => {
        console.log('BlogService - all articles:', articles);
        console.log('BlogService - looking for slug:', slug);
        const article = articles.find(a => a.slug === slug);
        console.log('BlogService - found article:', article);
        observer.next(article);
        observer.complete();
      });
    });
  }

  getPreviousArticle(currentSlug: string): Observable<BlogArticle | undefined> {
    return new Observable(observer => {
      this.getArticles().subscribe(articles => {
        const sortedArticles = articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        const currentIndex = sortedArticles.findIndex(a => a.slug === currentSlug);
        const previousArticle = currentIndex > 0 ? sortedArticles[currentIndex - 1] : undefined;
        observer.next(previousArticle);
        observer.complete();
      });
    });
  }

  getNextArticle(currentSlug: string): Observable<BlogArticle | undefined> {
    return new Observable(observer => {
      this.getArticles().subscribe(articles => {
        const sortedArticles = articles.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        const currentIndex = sortedArticles.findIndex(a => a.slug === currentSlug);
        const nextArticle = currentIndex < sortedArticles.length - 1 ? sortedArticles[currentIndex + 1] : undefined;
        observer.next(nextArticle);
        observer.complete();
      });
    });
  }
}

